import React from 'react';

import Imagem from 'Component/Imagem';
import { useAppSelector } from 'Store';

const Sistemas = (): React.ReactElement => {
  const token = useAppSelector((estado) => estado.autenticacao.token);

  return (
    <div className="bg-white rounded shadow-sm">
      <div className="bg-primary text-white rounded-top py-2 px-3 fs-4 d-flex justify-content-between align-items-center">
        Acesso aos sistemas
      </div>
      <div className="p-3 overflow-auto rounded">
        <button
          type="button"
          className="btn btn-transparent text-center"
          onClick={() =>
            window.open(`https://erp.tudogas.com.br/login?token=${token}`)
          }
        >
          <Imagem src="icone-erp.png" className="hf-50 d-block" />
          ERP
        </button>
        <button
          type="button"
          className="btn btn-transparent text-center"
          onClick={() =>
            window.open(`https://os.tudogas.com.br/login?token=${token}`)
          }
        >
          <Imagem src="icone-os.png" className="hf-50 d-block" />
          OS
        </button>
      </div>
    </div>
  );
};

export default Sistemas;

